/* ===========================================================================
 * cart-bundle-toggle.js — "Show N items" collapse for bundle lines in the cart
 * drawer. The CartTransform lineExpand renders a bundle parent line + nested
 * component lines (parent_relationship). Children are server-rendered collapsed
 * (.td-bundle-child--collapsed); the parent's [data-bundle-toggle] reveals them.
 * Delegated on document so it keeps working after Dawn swaps #CartDrawer.
 * State is not persisted across re-renders — bundles re-collapse on cart update.
 * =========================================================================== */
(function () {
  'use strict';
  if (window.__tdBundleToggle) return;
  window.__tdBundleToggle = true;

  function esc(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/["\\\]]/g, '\\$&');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-bundle-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    var key = btn.getAttribute('data-bundle-toggle');
    if (!key) return;

    var expanded = btn.getAttribute('aria-expanded') === 'true';
    // Read the centred image's top before the list opens and the row grows.
    var row = btn.closest ? btn.closest('tr.cart-item') : null;
    var img = row ? row.querySelector('.cart-item__image') : null;
    var pinTop = img && !expanded
      ? Math.round(img.getBoundingClientRect().top - img.parentNode.getBoundingClientRect().top)
      : null;
    // Real expanded child lines (prod / CartTransform):
    var rows = document.querySelectorAll('[data-bundle-child="' + esc(key) + '"]');
    for (var i = 0; i < rows.length; i++) {
      rows[i].classList.toggle('td-bundle-child--collapsed', expanded);
    }
    // Metafield component block rendered inside the parent line (dev / no CartTransform):
    var comps = document.querySelectorAll('[data-bundle-components="' + esc(key) + '"]');
    for (var j = 0; j < comps.length; j++) {
      comps[j].classList.toggle('td-bundle-components--collapsed', expanded);
    }
    btn.setAttribute('aria-expanded', String(!expanded));
    btn.classList.toggle('is-open', !expanded);
    // Flag the parent row so CSS can pin the product image to the top while
    // the component list is open (centred on the collapsed row otherwise).
    if (img && pinTop !== null) {
      img.style.top = pinTop + 'px';
      img.style.transform = 'none';
    } else if (img) {
      img.style.top = '';
      img.style.transform = '';
    }
    if (row) row.classList.toggle('td-bundle-open', !expanded);

    // Older markup swaps the label text; the current one stacks both labels and
    // lets CSS show the right one (.is-open), so the button width never changes.
    var label = btn.querySelector('.td-bundle-toggle__label');
    var show = btn.querySelector('.td-bundle-toggle__text--show');
    var hide = btn.querySelector('.td-bundle-toggle__text--hide');
    if (show && hide) {
      show.setAttribute('aria-hidden', String(!expanded));
      hide.setAttribute('aria-hidden', String(expanded));
    } else if (label) {
      var next = expanded ? btn.getAttribute('data-show-label') : btn.getAttribute('data-hide-label');
      if (next) label.textContent = next;
    }
  });
})();
